import { useState, useContext, memo, Fragment, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import {
  Accordion,
  useAccordionButton,
  AccordionContext,
  Nav,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";

import { useSelector } from "react-redux";
import * as SettingSelector from "../../../../store/setting/selectors";
import { useTranslation } from "react-i18next";

import RightArrow from "../../../custom/RightArrow";

import { BsFillBox2Fill, BsFillInboxesFill, BsLink45Deg } from "react-icons/bs";

import { AiOutlineAppstoreAdd } from "react-icons/ai";

import { SiCodereview } from "react-icons/si";

import { MdWidgets, MdOutlineCategory } from "react-icons/md";

import { BiCategoryAlt } from "react-icons/bi";

import { GrNewWindow } from "react-icons/gr";

import {
  FaBriefcase,
  FaUserTie,
  FaUsers,
  FaBell,
  FaLink,
  FaCoins,
  FaWallet,
  FaPaperPlane,
  FaBalanceScale,
  FaCog,
  FaGraduationCap,
  FaEnvelope,
  FaStar,
  FaMedal,
  FaShoppingCart,
} from "react-icons/fa";

import {
  MdOutlineTv,
  MdOutlineNewspaper,
  MdSwapHoriz,
  MdOutlineLocationCity,
  MdOutlineCalculate,
  MdOutlineFactCheck,
} from "react-icons/md";

import { TbGridDots } from "react-icons/tb";

function CustomToggle({ children, eventKey, onClick }) {
  const { activeEventKey } = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(eventKey, (active) =>
    onClick({ state: !active, eventKey: eventKey })
  );

  const isCurrentEventKey = activeEventKey === eventKey;

  return (
    <Link
      to="#"
      aria-expanded={isCurrentEventKey ? "true" : "false"}
      className="nav-link"
      role="button"
      onClick={(e) => {
        decoratedOnClick(isCurrentEventKey);
      }}
    >
      {children}
    </Link>
  );
}

const VerticalNav = memo(() => {
  const { t } = useTranslation();
  const [activeMenu, setActiveMenu] = useState(false);

  const [show1, setShow1] = useState(false);
  const [active, setActive] = useState("");

  // Detect mobile width to apply square icon-only style
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  let location = useLocation();
  const mode = useSelector(SettingSelector.theme_scheme_direction);
  const user = JSON.parse(localStorage.getItem("user"));
  console.log({ user });

  // Mobile: perfect square 44×44px icon-only button (overrides inline styles at source)
  const btnStyle = isMobile ? {
    width: '44px',
    height: '44px',
    minWidth: '44px',
    maxWidth: '44px',
    padding: '0',
    borderRadius: '8px',
    fontWeight: '600',
    backgroundColor: '#003366',
    border: '1px solid rgba(255,255,255,0.18)',
    color: '#fff',
    marginBottom: '0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    overflow: 'hidden',
    flexShrink: 0,
    boxShadow: '0 2px 6px rgba(0,0,0,0.18)',
    transition: 'background 0.18s ease, box-shadow 0.18s ease',
  } : {
    textAlign: 'left',
    padding: '10px 16px',
    borderRadius: '10px',
    fontWeight: '600',
    backgroundColor: '#003366',
    border: '1px solid rgba(255,255,255,0.08)',
    color: '#fff',
    marginBottom: '0px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'flex',
    alignItems: 'center',
    gap: '0px',
    fontSize: '13px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.18)',
    transition: 'background 0.18s ease, box-shadow 0.18s ease, transform 0.12s ease',
  };
  const iconBoxStyle = {
    width: '40px',
    height: '40px',
    minWidth: '40px',
    borderRadius: '10px',
    background: 'rgba(255,255,255,0.13)',
    border: '1px solid rgba(255,255,255,0.18)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
    flexShrink: 0,
    transition: 'background 0.18s ease',
  };
  const iconStyle = { fontSize: '20px', flexShrink: 0 };
  // On mobile: drop w-100 (Bootstrap overrides width:44px with width:100%!important) and text-start
  const btnClass = isMobile
    ? "btn mob-nav-btn"
    : "btn w-100 text-start mob-nav-btn";

  return (
    <Fragment className="">
      <Accordion as="ul" className="navbar-nav iq-main-menu">
        <li className="nav-item static-item"></li>
        <li className={` nav-item `}>
          <Link className={`nav-link`} aria-current="page" to="/shops">
            <div
              className={btnClass}
              style={{ ...btnStyle, ...(location.pathname.includes("/shop") && !location.pathname.includes("/business-analysis") ? { background: "#CCDAE0", color: "#003366" } : {}) }}
            >
              <FaBriefcase style={iconStyle} />
              <span>Businesses</span>
            </div>
          </Link>
        </li>
        <li className={` nav-item `}>
          <Link className={`nav-link`} aria-current="page" to="/business-analysis">
            <div
              className={btnClass}
              style={{ ...btnStyle, ...(location.pathname === "/business-analysis" ? { background: "#CCDAE0", color: "#003366" } : {}) }}
            >
              <MdOutlineCalculate style={iconStyle} />
              <span>Business Analysis</span>
            </div>
          </Link>
        </li>
        {user?.user_type == "super_admin" ||
          user?.user_type == "regional_admin" ? (
          <li className={` nav-item `}>
            <Link
              className={`nav-link`}
              aria-current="page"
              to="/humanResource/staff-list"
            >
              <div
                className={btnClass}
                style={{ ...btnStyle, ...(location.pathname === "/humanResource/staff-list" ? { background: "#CCDAE0", color: "#003366" } : {}) }}
              >
                <FaUserTie style={iconStyle} />
                <span>Staff Management</span>
              </div>
            </Link>
          </li>
        ) : null}

        {user?.user_type == "super_admin" ||
          user?.user_type == "regional_admin" ? (
          <li className="nav-item">
            <Link className="nav-link" aria-current="page" to="/used-items">
              <div
                className={btnClass}
                style={{ ...btnStyle, ...(location.pathname.startsWith("/used-items") ? { background: "#CCDAE0", color: "#003366" } : {}) }}
              >
                <FaShoppingCart style={iconStyle} />
                <span>Buy and Sale</span>
              </div>
            </Link>
          </li>
        ) : null}
        {user?.user_type == "super_admin" ||
          user?.user_type == "regional_admin" ? (
          <li className={` nav-item `}>
            <Link
              className={`nav-link`}
              aria-current="page"
              to="/businessApproval"
            >
              <div
                className={btnClass}
                style={{ ...btnStyle, ...(location.pathname === "/businessApproval" ? { background: "#CCDAE0", color: "#003366" } : {}) }}
              >
                <MdOutlineFactCheck style={iconStyle} />
                <span>Business Approval</span>
              </div>
            </Link>
          </li>
        ) : null}

        {user?.user_type == "super_admin" ||
          user?.user_type == "regional_admin" ? (
          <li className={` nav-item `}>
            <Link
              className={`nav-link`}
              aria-current="page"
              to="/categories/category"
            >
              <div
                className={btnClass}
                style={{ ...btnStyle, ...(location.pathname.includes("/categories") ? { background: "#CCDAE0", color: "#003366" } : {}) }}
              >
                <TbGridDots style={iconStyle} />
                <span>Category</span>
              </div>
            </Link>
          </li>
        ) : null}
        <li className={` nav-item `}>
          <Link className={`nav-link`} aria-current="page" to="/userManagment">
            <div
              className={btnClass}
              style={{ ...btnStyle, ...(location.pathname === "/userManagment" ? { background: "#CCDAE0", color: "#003366" } : {}) }}
            >
              <FaUsers style={iconStyle} />
              <span>UserManagment</span>
            </div>
          </Link>
        </li>
        {user?.user_type == "super_admin" ||
          user?.user_type == "regional_admin" ? (
          <li className={` nav-item `}>
            <Link className={`nav-link`} aria-current="page" to="/newschannel">
              <div
                className={btnClass}
                style={{ ...btnStyle, ...(location.pathname === "/newschannel" ? { background: "#CCDAE0", color: "#003366" } : {}) }}
              >
                <MdOutlineTv style={iconStyle} />
                <span>News Channel</span>
              </div>
            </Link>
          </li>
        ) : null}
        {user?.user_type == "super_admin" ||
          user?.user_type == "regional_admin" ? (
          <li className={` nav-item `}>
            <Link className={`nav-link`} aria-current="page" to="/newspaper">
              <div
                className={btnClass}
                style={{ ...btnStyle, ...(location.pathname === "/newspaper" ? { background: "#CCDAE0", color: "#003366" } : {}) }}
              >
                <MdOutlineNewspaper style={iconStyle} />
                <span>News Paper</span>
              </div>
            </Link>
          </li>
        ) : null}

        {user?.user_type == "super_admin" ||
          user?.user_type == "regional_admin" ? (
          <li className={` nav-item `}>
            <Link
              className={`nav-link`}
              aria-current="page"
              to="/subscriptiontransaction"
            >
              <div
                className={btnClass}
                style={{ ...btnStyle, ...(location.pathname === "/subscriptiontransaction" ? { background: "#CCDAE0", color: "#003366" } : {}) }}
              >
                <MdSwapHoriz style={{ fontSize: '24px', flexShrink: 0 }} />
                <span>Transaction</span>
              </div>
            </Link>
          </li>
        ) : null}
        {user?.user_type == "super_admin" ||
          user?.user_type == "regional_admin" ? (
          <li className={` nav-item `}>
            <Link
              className={`nav-link`}
              aria-current="page"
              to="/serviceLink"
            >
              <div
                className={btnClass}
                style={{ ...btnStyle, ...(location.pathname === "/serviceLink" ? { background: "#CCDAE0", color: "#003366" } : {}) }}
              >
                <FaLink style={iconStyle} />
                <span>Service Link</span>
              </div>
            </Link>
          </li>
        ) : null}

        {user?.user_type == "super_admin" ||
          user?.user_type == "regional_admin" ? (
          <li className={` nav-item `}>
            <Link
              className={`nav-link`}
              aria-current="page"
              to="/ads"
            >
              <div
                className={btnClass}
                style={{ ...btnStyle, ...(location.pathname === "/ads" ? { background: "#CCDAE0", color: "#003366" } : {}) }}
              >
                <MdOutlineLocationCity style={iconStyle} />
                <span>My City</span>
              </div>
            </Link>
          </li>
        ) : null}

        {user?.user_type == "super_admin" ||
          user?.user_type == "regional_admin" ? (
          <Accordion.Item
            as="li"
            eventKey="accounting"
            bsPrefix={`nav-item `}
            onClick={() => setActive("accounting")}
          >
            <CustomToggle
              eventKey="accounting"
              onClick={(activeKey) => setActiveMenu(activeKey)}
            >
              <div className={`${btnClass} d-flex align-items-center justify-content-between`} style={btnStyle}>
                <span style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                  <MdOutlineCalculate style={iconStyle} />
                  Accounting
                </span>
                <i className="right-icon">
                  <RightArrow />
                </i>
              </div>
            </CustomToggle>
            <Accordion.Collapse eventKey="accounting">
              <ul className="sub-nav">
                <Nav.Item
                  as="li"
                  style={
                    location.pathname === `/accounting/income` ||
                      location.pathname.includes("/accounting/income")
                      ? { background: "#CCDAE0", borderRadius: "6px" }
                      : {}
                  }
                >
                  <Link className={` nav-link`} to="/accounting/income">
                    <div className={btnClass} style={btnStyle}>
                      <FaCoins style={iconStyle} />
                      <span>Income</span>
                    </div>
                  </Link>
                </Nav.Item>

                <Nav.Item
                  as="li"
                  style={
                    location.pathname === `/accounting/expense` ||
                      location.pathname.includes("/accounting/expense")
                      ? { background: "#CCDAE0", borderRadius: "6px" }
                      : {}
                  }
                >
                  <Link className={` nav-link`} to="/accounting/expense">
                    <div className={btnClass} style={btnStyle}>
                      <FaWallet style={iconStyle} />
                      <span>Expense</span>
                    </div>
                  </Link>
                </Nav.Item>
                <Nav.Item
                  as="li"
                  style={
                    location.pathname === `/accounting/transfer` ||
                      location.pathname.includes("/accounting/transfer")
                      ? { background: "#CCDAE0", borderRadius: "6px" }
                      : {}
                  }
                >
                  <Link className={` nav-link`} to="/accounting/transfer">
                    <div className={btnClass} style={btnStyle}>
                      <FaPaperPlane style={iconStyle} />
                      <span>Transfer</span>
                    </div>
                  </Link>
                </Nav.Item>
                <Nav.Item
                  as="li"
                  style={
                    location.pathname === `/accounting/balance` ||
                      location.pathname.includes("/accounting/balance")
                      ? { background: "#CCDAE0", borderRadius: "6px" }
                      : {}
                  }
                >
                  <Link className={` nav-link`} to="/accounting/balance">
                    <div className={btnClass} style={btnStyle}>
                      <FaBalanceScale style={iconStyle} />
                      <span>Balance</span>
                    </div>
                  </Link>
                </Nav.Item>
              </ul>
            </Accordion.Collapse>
          </Accordion.Item>
        ) : null}

        {user?.user_type == "super_admin" ||
          user?.user_type == "regional_admin" ? (
          <li className={` nav-item `}>
            <Link
              className={`nav-link`}
              aria-current="page"
              to="/settings/bankDetails"
            >
              <div
                className={btnClass}
                style={{ ...btnStyle, ...(location.pathname.includes("/settings") ? { background: "#CCDAE0", color: "#003366" } : {}) }}
              >
                <FaCog style={iconStyle} />
                <span>Subscription</span>
              </div>
            </Link>
          </li>
        ) : null}

        {/* Extra Links - Last Item */}
        <li className={` nav-item `}>
          <Link
            className={`nav-link`}
            aria-current="page"
            to="/extra-subcategories"
          >
            <div
              className={btnClass}
              style={{ ...btnStyle, ...(location.pathname.includes("/extra-subcategories") ? { background: "#CCDAE0", color: "#003366" } : {}) }}
            >
              <FaGraduationCap style={iconStyle} />
              <span>Study Master</span>
            </div>
          </Link>
        </li>
        <li className={` nav-item `}>
          <Link
            className={`nav-link`}
            aria-current="page"
            to="/greeting-message"
          >
            <div
              className={btnClass}
              style={{ ...btnStyle, ...(location.pathname === "/greeting-message" ? { background: "#CCDAE0", color: "#003366" } : {}) }}
            >
              <FaEnvelope style={iconStyle} />
              <span>Greeting Message</span>
            </div>
          </Link>
        </li>
        <li className={` nav-item `}>
          <Link
            className={`nav-link`}
            aria-current="page"
            to="/extra-items"
          >
            <div
              className={btnClass}
              style={{ ...btnStyle, ...(location.pathname === "/extra-items" ? { background: "#CCDAE0", color: "#003366" } : {}) }}
            >
              <FaStar style={iconStyle} />
              <span>Influencer</span>
            </div>
          </Link>
        </li>
        <li className={` nav-item `}>
          <Link
            className={`nav-link`}
            aria-current="page"
            to="/recognition"
          >
            <div
              className={btnClass}
              style={{ ...btnStyle, ...(location.pathname === "/recognition" ? { background: "#CCDAE0", color: "#003366" } : {}) }}
            >
              <FaMedal style={iconStyle} />
              <span>Recognition</span>
            </div>
          </Link>
        </li>
      </Accordion>
    </Fragment>
  );
});

VerticalNav.displayName = "VerticalNav";
export default VerticalNav;

